import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class AttributeDisplay extends React.Component {
  getCustomValuesDisplay = data => {
    if (data.type === "LIST") {
      return (
        <ListValueDisplay
          values={data.acceptedValues}
          valuePrefix="Property Values"
        />
      );
    }
    return <div></div>;
  };

  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(CrudlStatus.VIEW, bean);
          }
        }}
      >
        <div className="ui-g-12">
          <h2>Attribute Summary: </h2>
          <label />

          <div className="ui-g-2 row"></div>
          <div className="ui-g-8 row">
            <div className="ui-g-8 cell">
              <b style={{ float: "right" }}>Name: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Description: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Type: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Unit Of Measurement: </b>
            </div>

            <div className="ui-g-8 cell">
              <label>{bean.name || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.description || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.type || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.unitOfMeasurement || "Not Set"}</label>
            </div>
          </div>
          <div>{this.getCustomValuesDisplay(bean)}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/UI/AttributeDisplay.js